module.exports = "<div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} bounceIn animated  alert-dismissable\" \nstyle=\"width: 20%;cursor: pointer; position: absolute;right: 5%;bottom: 5%;\">\n     {{alert.message}}\n     <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_directives/alert.component.html
// module id = ./src/app/_directives/alert.component.html
// module chunks = main